export const formatCurrencyCode = currency => (currency ? String(currency).toUpperCase() : '');

export const formatMoneyAmount = value =>
  Number(value || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatWalletMoney = (value, currency) => {
  const amount = formatMoneyAmount(value);

  if (!currency) {
    return amount;
  }

  return `${formatCurrencyCode(currency)} ${amount}`;
};

export const formatWalletUser = user => {
  if (!user) {
    return '—';
  }

  const fullName =
    user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email;

  return fullName || '—';
};

export const getTransactionExchangeRate = transaction =>
  transaction?.exchangeRate ?? transaction?.metaData?.settlementExchangeRate ?? null;

export const getTransactionDisplayExchangeRate = transaction => {
  const originalCurrency = String(
    transaction?.originalCurrency || transaction?.metaData?.originalCurrency || ''
  ).toLowerCase();
  const settlementCurrency = String(transaction?.currency || '').toLowerCase();

  if (originalCurrency && settlementCurrency && originalCurrency === settlementCurrency) {
    return 1;
  }

  const rate = getTransactionExchangeRate(transaction);
  return rate != null ? Number(rate) : null;
};
